import type { PageTemplateThumb } from "./page-template-thumb";
/** Compact saved page preview. It is never an activation or editor payload. */
export type WorkspacePagePreview = {
  identity: string;
  pageId: string;
  title: string;
  icon: string | null;
  description: string;
  /** Saved, bounded schematic structure; null only for old/unindexed pages. */
  structure: PageTemplateThumb | null;
  cover: string | null;
  hasCover: boolean;
};

export const WORKSPACE_PREVIEW_DELAY_MS = 900;
export const WORKSPACE_PREVIEW_CACHE_MS = 30_000;
export const WORKSPACE_PREVIEW_CACHE_LIMIT = 16;

export const WORKSPACE_PAGE_PREVIEW_CLOSED = "frogstat:page-preview-closed";
